module.exports = __webpack_public_path__ + "static/img/temp_bg.8aee5fb1.png";